import {
  BookOpen,
  Calendar,
  ChartArea,
  Clapperboard,
  GraduationCap,
  MessageSquare,
  Tv,
  UserRound,
} from 'lucide-solid'
import type { Component } from 'solid-js'

export type SearchCategory =
  | 'setup'
  | 'chat'
  | 'course'
  | 'event'
  | 'recording'
  | 'go_read'
  | 'go_watch'
  | 'member'

export type CategoryConfig = {
  key: SearchCategory
  label: string
  /** Singular label used on each result row */
  singular: string
  // biome-ignore lint/suspicious/noExplicitAny: lucide icon component
  icon: Component<any>
  color: string
  /** Section of the app this category belongs to (used to rank it first while you're there) */
  section: string
  /**
   * Page that can show the full result set for a query, with that page's own filters.
   * Categories without one expand inside the palette instead.
   */
  seeAll?: (q: string) => string
}

const withQ = (path: string) => (q: string) => `${path}?q=${encodeURIComponent(q)}`

export const CATEGORIES: CategoryConfig[] = [
  { key: 'setup', label: 'Setups', singular: 'Setup', icon: ChartArea, color: '#22a06b', section: '/setups', seeAll: withQ('/setups') },
  { key: 'chat', label: 'Chat', singular: 'Message', icon: MessageSquare, color: '#2f79e0', section: '/chat' },
  { key: 'recording', label: 'Recordings', singular: 'Recording', icon: Tv, color: '#e5484d', section: '/recordings', seeAll: withQ('/recordings') },
  { key: 'course', label: 'Courses', singular: 'Course', icon: GraduationCap, color: '#f59e0b', section: '/courses', seeAll: withQ('/courses') },
  { key: 'event', label: 'Events', singular: 'Event', icon: Calendar, color: '#8257e6', section: '/events', seeAll: withQ('/events') },
  { key: 'go_read', label: 'Go Read', singular: 'Article', icon: BookOpen, color: '#0ea5a4', section: '/go-read', seeAll: withQ('/go-read') },
  { key: 'go_watch', label: 'Go Watch', singular: 'Video', icon: Clapperboard, color: '#d6409f', section: '/go-watch', seeAll: withQ('/go-watch') },
  { key: 'member', label: 'Members', singular: 'Member', icon: UserRound, color: '#6e7781', section: '' },
]

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.key, c])) as Record<
  SearchCategory,
  CategoryConfig
>

/** The category that matches the page you're on, if any */
export const categoryForPath = (pathname: string): SearchCategory | undefined =>
  CATEGORIES.find((c) => c.section && pathname.startsWith(c.section))?.key
